module.exports = __webpack_public_path__ + "static/media/martin_bernstein_3.7d8e929f.png";